import { InferActionFromThunk } from '../../common/action';
import { postData } from '../../common/actions';
import { REFRESH_SESSION_ACTION } from '../../common/constants/session';

export type SessionActions = InferActionFromThunk<typeof createSessionRefreshAction>;

export const createSessionRefreshAction = (conversationUuid: string) =>
    postData(REFRESH_SESSION_ACTION, 'session/keepAlive', { conversationUuid });
